const yearElement = document.getElementById('year');
if (yearElement) {
  yearElement.textContent = new Date().getFullYear();
}

const menuToggle = document.querySelector('.menu-toggle');
const mainNav = document.querySelector('.main-nav');
const navActions = document.querySelector('.nav-actions');

if (menuToggle && mainNav && navActions) {
  menuToggle.addEventListener('click', () => {
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));

    const isMobileNavVisible = mainNav.style.display === 'flex';
    mainNav.style.display = isMobileNavVisible ? 'none' : 'flex';
    navActions.style.display = isMobileNavVisible ? 'none' : 'flex';

    mainNav.style.flexDirection = 'column';
    mainNav.style.position = 'absolute';
    mainNav.style.top = '78px';
    mainNav.style.left = '1rem';
    mainNav.style.right = '1rem';
    mainNav.style.padding = '1rem';
    mainNav.style.background = 'white';
    mainNav.style.border = '1px solid rgba(17, 24, 39, 0.08)';
    mainNav.style.borderRadius = '16px';
    mainNav.style.boxShadow = '0 18px 32px rgba(17, 24, 39, 0.08)';

    navActions.style.flexDirection = 'column';
    navActions.style.position = 'absolute';
    navActions.style.top = 'calc(78px + 200px)';
    navActions.style.left = '1rem';
    navActions.style.right = '1rem';
    navActions.style.padding = '0.75rem';
    navActions.style.background = 'white';
    navActions.style.border = '1px solid rgba(17, 24, 39, 0.08)';
    navActions.style.borderRadius = '16px';
    navActions.style.boxShadow = '0 18px 32px rgba(17, 24, 39, 0.08)';
  });
}

const faqItems = document.querySelectorAll('.faq-item');
faqItems.forEach((item) => {
  const button = item.querySelector('.faq-question');

  if (!button) return;

  button.addEventListener('click', () => {
    const isOpen = item.classList.contains('active');

    faqItems.forEach((faqItem) => {
      faqItem.classList.remove('active');
      faqItem.querySelector('.faq-question')?.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  });
});

const newsletterForm = document.querySelector('.newsletter-form');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const button = newsletterForm.querySelector('button');
    if (button) {
      const originalText = button.textContent;
      button.textContent = '¡Gracias!';
      button.disabled = true;

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        newsletterForm.reset();
      }, 1800);
    }
  });
}
